import {useState,useEffect} from "react";
import realtimeDB from "../Utils/api";
const usePedidos=()=>
{
    const [Pedidos, setPedidos] = useState([]);
    useEffect(() => 
    {
      
        realtimeDB.ref("/Pedidos").on("value",snapshot =>
        {
            var pedidos=[];
            snapshot.forEach(pedido =>
            {
                const {Estado}=pedido.val();
                if(Estado!=="Completado")
                {
                    pedidos.push({id:pedido.key,data:pedido.val()})
                }
            })
            setPedidos(pedidos);
        })
       
    }, [])
    return Pedidos
}

export default usePedidos;